import imageConfig from "../config/imageConfig";
import { no_images } from "./ImagePath";

// Regex constants
export const nameRegex = "^[A-Za-z. ]+$";
export const emailRegex = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$";
export const phoneRegex = "^[6-9]{1}[0-9]{10}$";
export const contactRegex = "/^(?:[1-9]+|)(?:.{1,2})?$/";


export const capitalizeWords = (string) => {
    if (!string) return '';
    return string
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const formatDate = (dateString) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
};

export const travelersClass = {
    "ECONOMY": "Economy",
    "PREMIUM_ECONOMY": "Premium",
    "BUSINESS": "Business",
    "FIRST": "First Class"
}

export const getImageUrl = (item, size = 'gallery') => {
    const baseUrls = {
        ORIGINAL: imageConfig.ORIGINAL_IMAGE_URL,
        BANNER: imageConfig.BANNER_IMAGE_URL,
        GALLERY: imageConfig.GALLERY_IMAGE_URL,
        HOME: imageConfig.HOME_IMAGE_URL,
        ITERNARY: imageConfig.ITERNARY_IMAGE_URL,
        THUMB: imageConfig.THUMB_IMAGE_URL,
    };

    const sizeKey = size.toUpperCase();
    const baseUrl = baseUrls[sizeKey] || imageConfig.GALLERY_IMAGE_URL;
    if (typeof item === 'string') {
        return item.startsWith('https') ? item : baseUrl + item;
    }
    else if (item?.image_url) {
        return item.image_url.startsWith('https') ? item.image_url : baseUrl + item.image_url;
    }
    return no_images;
};


export const CONSTANTS = {
    hotelRedeemedDiscount: 12,
    holidayRedeemedDiscount: 5
};


export const dataHotel =
    [
        {
            "CityName": "Harads",
            "CountryName": "Sweden",
            "CountryCode": "SE",
            "CityCode": "119963"
        },
        {
            "CityName": "Harare",
            "CountryName": "Zimbabwe",
            "CountryCode": "ZW",
            "CityCode": "119964"
        },
        {
            "CityName": "Harbach",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "119965"
        },
        {
            "CityName": "Harding",
            "CountryName": "South Africa",
            "CountryCode": "ZA",
            "CityCode": "119966"
        },
        {
            "CityName": "Harich",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "119967"
        },
        {
            "CityName": "Harlan",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "119968"
        },
        {
            "CityName": "Harnosand",
            "CountryName": "Sweden",
            "CountryCode": "SE",
            "CityCode": "119969"
        },
        {
            "CityName": "Harpers Ferry",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "119970"
        },
        {
            "CityName": "Harrisonville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "119971"
        },
        {
            "CityName": "Harvest",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "119972"
        },
        {
            "CityName": "Gro?harthau",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120136"
        },
        {
            "CityName": "Harahan",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120202"
        },
        {
            "CityName": "Harbourville",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "120208"
        },
        {
            "CityName": "Hard",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "120209"
        },
        {
            "CityName": "Hardheim",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120210"
        },
        {
            "CityName": "Harlech",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120211"
        },
        {
            "CityName": "Harlingen",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120212"
        },
        {
            "CityName": "Harpswell",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120213"
        },
        {
            "CityName": "Harriman",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120214"
        },
        {
            "CityName": "Harrison",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120215"
        },
        {
            "CityName": "Harrison Mills",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "120216"
        },
        {
            "CityName": "Hartbeespoort",
            "CountryName": "South Africa",
            "CountryCode": "ZA",
            "CityCode": "120217"
        },
        {
            "CityName": "Hartmannsdorf",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120218"
        },
        {
            "CityName": "Hartola",
            "CountryName": "Finland",
            "CountryCode": "FI",
            "CityCode": "120219"
        },
        {
            "CityName": "Hart's Location",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120220"
        },
        {
            "CityName": "Hartselle",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120221"
        },
        {
            "CityName": "Madzharovo",
            "CountryName": "Bulgaria",
            "CountryCode": "BG",
            "CityCode": "104014"
        },
        {
            "CityName": "Makinohara",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "104020"
        },
        {
            "CityName": "Nahariyah",
            "CountryName": "Israel",
            "CountryCode": "IL",
            "CityCode": "104263"
        },
        {
            "CityName": "Margaree Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "104326"
        },
        {
            "CityName": "Mauleon-Licharre",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "104338"
        },
        {
            "CityName": "Charette",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "104916"
        },
        {
            "CityName": "Barichara",
            "CountryName": "Colombia",
            "CountryCode": "CO",
            "CityCode": "105030"
        },
        {
            "CityName": "Bharmour",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "105046"
        },
        {
            "CityName": "Al-Kharj",
            "CountryName": "Saudi Arabia",
            "CountryCode": "SA",
            "CityCode": "105080"
        },
        {
            "CityName": "Charlton",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "105248"
        },
        {
            "CityName": "Charlton Marshall",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "105249"
        },
        {
            "CityName": "Beauharnois",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "105278"
        },
        {
            "CityName": "Aberdeen Harbour",
            "CountryName": "Hong Kong",
            "CountryCode": "HK",
            "CityCode": "100439"
        },
        {
            "CityName": "Acharavi",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "100447"
        },
        {
            "CityName": "Advocate Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "100455"
        },
        {
            "CityName": "Makuhari",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "101263"
        },
        {
            "CityName": "Costa de Azahar",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "101363"
        },
        {
            "CityName": "Charge",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "101410"
        },
        {
            "CityName": "Harmanli",
            "CountryName": "Bulgaria",
            "CountryCode": "BG",
            "CityCode": "101545"
        },
        {
            "CityName": "Harbour Grace",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "101779"
        },
        {
            "CityName": "Mouchard",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "101912"
        },
        {
            "CityName": "Pancharevo",
            "CountryName": "Bulgaria",
            "CountryCode": "BG",
            "CityCode": "102083"
        },
        {
            "CityName": "Coochbehar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "102287"
        },
        {
            "CityName": "Dharampur",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "102310"
        },
        {
            "CityName": "Harbiye",
            "CountryName": "Turkey",
            "CountryCode": "TR",
            "CityCode": "102431"
        },
        {
            "CityName": "Hartenbos",
            "CountryName": "South Africa",
            "CountryCode": "ZA",
            "CityCode": "102432"
        },
        {
            "CityName": "Harty",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "102433"
        },
        {
            "CityName": "Harjumaa",
            "CountryName": "Estonia",
            "CountryCode": "EE",
            "CityCode": "102446"
        },
        {
            "CityName": "Harlev",
            "CountryName": "Denmark",
            "CountryCode": "DK",
            "CityCode": "102447"
        },
        {
            "CityName": "Harpham",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "102448"
        },
        {
            "CityName": "Hartshorne",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "102449"
        },
        {
            "CityName": "Harkensee",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "102507"
        },
        {
            "CityName": "Harrietville",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "102508"
        },
        {
            "CityName": "Mount Pritchard",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "102841"
        },
        {
            "CityName": "Nova Hartz",
            "CountryName": "Brazil",
            "CountryCode": "BR",
            "CityCode": "102883"
        },
        {
            "CityName": "Sabhar",
            "CountryName": "Bangladesh",
            "CountryCode": "BD",
            "CityCode": "102969"
        },
        {
            "CityName": "Petty Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "103273"
        },
        {
            "CityName": "Saharanpur",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "103325"
        },
        {
            "CityName": "Salekhard",
            "CountryName": "Russia",
            "CountryCode": "RU",
            "CityCode": "103493"
        },
        {
            "CityName": "Scharja",
            "CountryName": "Russia",
            "CountryCode": "RU",
            "CityCode": "103568"
        },
        {
            "CityName": "Jolly Harbour",
            "CountryName": "Antigua & Barbuda",
            "CountryCode": "AG",
            "CityCode": "103939"
        },
        {
            "CityName": "Chardonnay",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "105371"
        },
        {
            "CityName": "Charlwood",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "105373"
        },
        {
            "CityName": "Charron",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "105374"
        },
        {
            "CityName": "Deoghar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "105482"
        },
        {
            "CityName": "Kuruppanthara",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "105541"
        },
        {
            "CityName": "Isehara",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "105605"
        },
        {
            "CityName": "Harcourt",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "105840"
        },
        {
            "CityName": "Harfleur",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "105841"
        },
        {
            "CityName": "Clifton Harbour",
            "CountryName": "St. Vincent & the Grenadines",
            "CountryCode": "VC",
            "CityCode": "106225"
        },
        {
            "CityName": "Dharavandhoo",
            "CountryName": "Maldives",
            "CountryCode": "MV",
            "CityCode": "106256"
        },
        {
            "CityName": "Speinshart",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "106336"
        },
        {
            "CityName": "Kashary",
            "CountryName": "Russia",
            "CountryCode": "RU",
            "CityCode": "122849"
        },
        {
            "CityName": "Kastelbell-Tschars",
            "CountryName": "Italy",
            "CountryCode": "IT",
            "CityCode": "122851"
        },
        {
            "CityName": "Karlsdorf-Neuthard",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "122943"
        },
        {
            "CityName": "Karrantza Harana/Valle de Carranza",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "123097"
        },
        {
            "CityName": "La Charite sur Loire",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "123375"
        },
        {
            "CityName": "La Mothe-Achard",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "123945"
        },
        {
            "CityName": "Koschariza",
            "CountryName": "Bulgaria",
            "CountryCode": "BG",
            "CityCode": "124003"
        },
        {
            "CityName": "La Chartre-sur-le-Loir",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "124060"
        },
        {
            "CityName": "Lake Harmony",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "124090"
        },
        {
            "CityName": "Bourg-Achard",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "112332"
        },
        {
            "CityName": "Burkhardtsdorf",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "113009"
        },
        {
            "CityName": "Bsharri",
            "CountryName": "Lebanon",
            "CountryCode": "LB",
            "CityCode": "113196"
        },
        {
            "CityName": "Bucharest",
            "CountryName": "Romania",
            "CountryCode": "RO",
            "CityCode": "113200"
        },
        {
            "CityName": "Cams Wharf",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "113337"
        },
        {
            "CityName": "Bukhara",
            "CountryName": "Uzbekistan",
            "CountryCode": "UZ",
            "CityCode": "113442"
        },
        {
            "CityName": "Castilleja de Talhara",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "113555"
        },
        {
            "CityName": "Chardonne",
            "CountryName": "Switzerland",
            "CountryCode": "CH",
            "CityCode": "113689"
        },
        {
            "CityName": "Charlotte",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "113690"
        },
        {
            "CityName": "Charmes",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "113691"
        },
        {
            "CityName": "Cape Charles",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "113828"
        },
        {
            "CityName": "Charette-Varennes",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114116"
        },
        {
            "CityName": "Charholi Budruk",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "114117"
        },
        {
            "CityName": "Charleston",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114118"
        },
        {
            "CityName": "Charlestown",
            "CountryName": "St. Kitts and Nevis",
            "CountryCode": "KN",
            "CityCode": "114119"
        },
        {
            "CityName": "Charleville",
            "CountryName": "Ireland",
            "CountryCode": "IE",
            "CityCode": "114120"
        },
        {
            "CityName": "Charlieu",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114121"
        },
        {
            "CityName": "Charlotte Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114122"
        },
        {
            "CityName": "Charmey",
            "CountryName": "Switzerland",
            "CountryCode": "CH",
            "CityCode": "114123"
        },
        {
            "CityName": "Chartres-de-Bretagne",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114124"
        },
        {
            "CityName": "Charenton-le-Pont",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114243"
        },
        {
            "CityName": "Charleston",
            "CountryName": "New Zealand",
            "CountryCode": "NZ",
            "CityCode": "114244"
        },
        {
            "CityName": "Chartres",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114245"
        },
        {
            "CityName": "Charzykowy",
            "CountryName": "Poland",
            "CountryCode": "PL",
            "CityCode": "114246"
        },
        {
            "CityName": "Coffs Harbour",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "114327"
        },
        {
            "CityName": "Charente-Maritime",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114494"
        },
        {
            "CityName": "Charleroi",
            "CountryName": "Belgium",
            "CountryCode": "BE",
            "CityCode": "114495"
        },
        {
            "CityName": "Charles City",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114496"
        },
        {
            "CityName": "Charleville-Mezieres",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114497"
        },
        {
            "CityName": "Charlottetown",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "114498"
        },
        {
            "CityName": "Charlton",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "114499"
        },
        {
            "CityName": "Charmouth",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "114500"
        },
        {
            "CityName": "Charolles",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114501"
        },
        {
            "CityName": "Chartham",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "114502"
        },
        {
            "CityName": "Chard",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "114611"
        },
        {
            "CityName": "Charleston",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114612"
        },
        {
            "CityName": "Charlestown",
            "CountryName": "Ireland",
            "CountryCode": "IE",
            "CityCode": "114613"
        },
        {
            "CityName": "Charlevoix",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114614"
        },
        {
            "CityName": "Charlotte Amalie",
            "CountryName": "U.S. Virgin Islands",
            "CountryCode": "VI",
            "CityCode": "114615"
        },
        {
            "CityName": "Charlottenberg",
            "CountryName": "Sweden",
            "CountryCode": "SE",
            "CityCode": "114616"
        },
        {
            "CityName": "Charlottesville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114617"
        },
        {
            "CityName": "Charneca da Caparica",
            "CountryName": "Portugal",
            "CountryCode": "PT",
            "CityCode": "114618"
        },
        {
            "CityName": "Charny",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114619"
        },
        {
            "CityName": "Charters Towers",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "114620"
        },
        {
            "CityName": "Charing",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "114713"
        },
        {
            "CityName": "Charkia",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "114714"
        },
        {
            "CityName": "Charles Town",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114715"
        },
        {
            "CityName": "Charleston",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114716"
        },
        {
            "CityName": "Charlestown",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114717"
        },
        {
            "CityName": "Charlotte",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "114718"
        },
        {
            "CityName": "Chaumont-sur-Tharonne",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114781"
        },
        {
            "CityName": "Clohars-Carnoet",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114854"
        },
        {
            "CityName": "Central Kalahari Game Reserve",
            "CountryName": "Botswana",
            "CountryCode": "BW",
            "CityCode": "114914"
        },
        {
            "CityName": "Charavines",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "114947"
        },
        {
            "CityName": "Charkow",
            "CountryName": "Ukraine",
            "CountryCode": "UA",
            "CityCode": "114948"
        },
        {
            "CityName": "Charlos Cove",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "114949"
        },
        {
            "CityName": "Charlwood",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "114950"
        },
        {
            "CityName": "Chartwell",
            "CountryName": "South Africa",
            "CountryCode": "ZA",
            "CityCode": "114951"
        },
        {
            "CityName": "Dharamshala",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "115880"
        },
        {
            "CityName": "East Hartford",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "115977"
        },
        {
            "CityName": "Courtown Harbour",
            "CountryName": "Ireland",
            "CountryCode": "IE",
            "CityCode": "115988"
        },
        {
            "CityName": "Darling Harbour",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "116148"
        },
        {
            "CityName": "Dalhart",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "116251"
        },
        {
            "CityName": "Tahara",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "138563"
        },
        {
            "CityName": "Sharnbrook",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "138658"
        },
        {
            "CityName": "Straubenhardt-Schwann",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "139123"
        },
        {
            "CityName": "Steinhardt",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "139248"
        },
        {
            "CityName": "St. Gotthard",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "139471"
        },
        {
            "CityName": "St. Lyphard",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "139478"
        },
        {
            "CityName": "Tatoi - Acharnai",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "139570"
        },
        {
            "CityName": "Tharandt",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "139739"
        },
        {
            "CityName": "Tambach-Dietharz",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "139907"
        },
        {
            "CityName": "Twain Harte",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "140091"
        },
        {
            "CityName": "Montrichard",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "128517"
        },
        {
            "CityName": "Moorbad Harbach",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "128524"
        },
        {
            "CityName": "Muharrak",
            "CountryName": "Bahrain",
            "CountryCode": "BH",
            "CityCode": "128566"
        },
        {
            "CityName": "Murrhardt",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "128685"
        },
        {
            "CityName": "Naharija",
            "CountryName": "Israel",
            "CountryCode": "IL",
            "CityCode": "128706"
        },
        {
            "CityName": "Mundling-Harburg",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "129092"
        },
        {
            "CityName": "Neustadt/Harz",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "129214"
        },
        {
            "CityName": "New Hartford",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "129328"
        },
        {
            "CityName": "Neufchatel-Hardelot",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "129771"
        },
        {
            "CityName": "Neuharlingersiel",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "129834"
        },
        {
            "CityName": "Oak Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130057"
        },
        {
            "CityName": "Oberbernhards",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "130065"
        },
        {
            "CityName": "National Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130124"
        },
        {
            "CityName": "Old Orchard Beach",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130230"
        },
        {
            "CityName": "Osterode am Harz",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "130275"
        },
        {
            "CityName": "Pacific Harbour",
            "CountryName": "Fiji Islands",
            "CountryCode": "FJ",
            "CityCode": "130304"
        },
        {
            "CityName": "Musquodoboit Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "130339"
        },
        {
            "CityName": "Nahar Magra",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "130354"
        },
        {
            "CityName": "Nai Harn Beach",
            "CountryName": "Thailand",
            "CountryCode": "TH",
            "CityCode": "130355"
        },
        {
            "CityName": "New Harmony",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130444"
        },
        {
            "CityName": "Norten-Hardenberg",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "130513"
        },
        {
            "CityName": "North Charleston",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130518"
        },
        {
            "CityName": "Oberharmersbach",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "130599"
        },
        {
            "CityName": "Orchard Park",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130681"
        },
        {
            "CityName": "Osterholz-Scharmbeck",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "130708"
        },
        {
            "CityName": "Palm Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130754"
        },
        {
            "CityName": "Noord-Scharwoude",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "130888"
        },
        {
            "CityName": "Northeast Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "130902"
        },
        {
            "CityName": "Newmachar",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "131106"
        },
        {
            "CityName": "Pittenhart",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "131654"
        },
        {
            "CityName": "Plouharnel",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "131793"
        },
        {
            "CityName": "Harkingen",
            "CountryName": "Switzerland",
            "CountryCode": "CH",
            "CityCode": "108288"
        },
        {
            "CityName": "Katihar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "108361"
        },
        {
            "CityName": "Sukoharjo",
            "CountryName": "Indonesia",
            "CountryCode": "ID",
            "CityCode": "108578"
        },
        {
            "CityName": "Alpharetta",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "109068"
        },
        {
            "CityName": "Bad St. Leonhard im Lavanttal",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "109707"
        },
        {
            "CityName": "Baileys Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "109725"
        },
        {
            "CityName": "Bad Harzburg",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "109795"
        },
        {
            "CityName": "Bal Harbour/Miami Beach",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "109824"
        },
        {
            "CityName": "Arrochar",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "109976"
        },
        {
            "CityName": "Bad Haring",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "110057"
        },
        {
            "CityName": "Bacharach",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "110269"
        },
        {
            "CityName": "Bellharbour",
            "CountryName": "Ireland",
            "CountryCode": "IE",
            "CityCode": "110488"
        },
        {
            "CityName": "Benton Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "110596"
        },
        {
            "CityName": "Bahariya Oasis",
            "CountryName": "Egypt",
            "CountryCode": "EG",
            "CityCode": "110744"
        },
        {
            "CityName": "Ban Harn Beach",
            "CountryName": "Thailand",
            "CountryCode": "TH",
            "CityCode": "110850"
        },
        {
            "CityName": "Bay Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "110892"
        },
        {
            "CityName": "Bad Wimsbach-Neydharting",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "111070"
        },
        {
            "CityName": "Bar Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "111131"
        },
        {
            "CityName": "Bharuch",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "111195"
        },
        {
            "CityName": "Boothbay Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "111276"
        },
        {
            "CityName": "Bharatpur",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "111484"
        },
        {
            "CityName": "Battle Harbour Island",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "144130"
        },
        {
            "CityName": "Blanchard",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "144273"
        },
        {
            "CityName": "Brives-Charensac",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "144385"
        },
        {
            "CityName": "Chance Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "144620"
        },
        {
            "CityName": "Charaki",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "144625"
        },
        {
            "CityName": "Charbonnieres-les-Bains",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "144626"
        },
        {
            "CityName": "Chariton",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "144627"
        },
        {
            "CityName": "Charlbury",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "144628"
        },
        {
            "CityName": "Charleston",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "144629"
        },
        {
            "CityName": "Charlestown",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "144630"
        },
        {
            "CityName": "Charleville",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "144631"
        },
        {
            "CityName": "Charlottenlund",
            "CountryName": "Denmark",
            "CountryCode": "DK",
            "CityCode": "144632"
        },
        {
            "CityName": "Charmes-sur-Rhone",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "144633"
        },
        {
            "CityName": "Charquemont",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "144634"
        },
        {
            "CityName": "Charvensod",
            "CountryName": "Italy",
            "CountryCode": "IT",
            "CityCode": "144635"
        },
        {
            "CityName": "Dharmapuri",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "144913"
        },
        {
            "CityName": "El Charco del Palo",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "145053"
        },
        {
            "CityName": "Falmouth Harbour",
            "CountryName": "Antigua & Barbuda",
            "CountryCode": "AG",
            "CityCode": "145150"
        },
        {
            "CityName": "Frumoasa (Harghita)",
            "CountryName": "Romania",
            "CountryCode": "RO",
            "CityCode": "145279"
        },
        {
            "CityName": "Harau",
            "CountryName": "Romania",
            "CountryCode": "RO",
            "CityCode": "145537"
        },
        {
            "CityName": "Harker Heights",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "145538"
        },
        {
            "CityName": "Harre",
            "CountryName": "Belgium",
            "CountryCode": "BE",
            "CityCode": "145539"
        },
        {
            "CityName": "Harrietsham",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "145540"
        },
        {
            "CityName": "Harstad",
            "CountryName": "Norway",
            "CountryCode": "NO",
            "CityCode": "145541"
        },
        {
            "CityName": "Hart",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "145542"
        },
        {
            "CityName": "Hartington",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "145543"
        },
        {
            "CityName": "Hartsville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "145544"
        },
        {
            "CityName": "Harvey",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "145545"
        },
        {
            "CityName": "Hubballi-Dharwad",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "145694"
        },
        {
            "CityName": "Indian Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "145746"
        },
        {
            "CityName": "Kharga Oasis",
            "CountryName": "Egypt",
            "CountryCode": "EG",
            "CityCode": "145928"
        },
        {
            "CityName": "Lake Charles",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "146108"
        },
        {
            "CityName": "Guethary",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "120425"
        },
        {
            "CityName": "Hainrode (Sudharz)",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120453"
        },
        {
            "CityName": "Harbertonford",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120474"
        },
        {
            "CityName": "Hardeeville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120475"
        },
        {
            "CityName": "Harderwijk",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "120476"
        },
        {
            "CityName": "Haria",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "120477"
        },
        {
            "CityName": "Harkany",
            "CountryName": "Hungary",
            "CountryCode": "HU",
            "CityCode": "120478"
        },
        {
            "CityName": "Harlesiel",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120479"
        },
        {
            "CityName": "Harleyville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120480"
        },
        {
            "CityName": "Harlingen",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "120481"
        },
        {
            "CityName": "Harlow",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120482"
        },
        {
            "CityName": "Harpenden",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120483"
        },
        {
            "CityName": "Harpstedt",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120484"
        },
        {
            "CityName": "Harrington",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120485"
        },
        {
            "CityName": "Harrison",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120486"
        },
        {
            "CityName": "Harrisonburg",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120487"
        },
        {
            "CityName": "Harsefeld",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120488"
        },
        {
            "CityName": "Hartberg",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "120489"
        },
        {
            "CityName": "Hartenstein",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120490"
        },
        {
            "CityName": "Harth-Pollnitz",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120491"
        },
        {
            "CityName": "Hartland",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120492"
        },
        {
            "CityName": "Hartland (Devon)",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120493"
        },
        {
            "CityName": "Harvard",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120494"
        },
        {
            "CityName": "Harbor Springs",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120607"
        },
        {
            "CityName": "Hardenberg",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "120608"
        },
        {
            "CityName": "Harmarville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120609"
        },
        {
            "CityName": "Haro",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "120610"
        },
        {
            "CityName": "Harrismith",
            "CountryName": "South Africa",
            "CountryCode": "ZA",
            "CityCode": "120611"
        },
        {
            "CityName": "Harrisville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120612"
        },
        {
            "CityName": "Harryda",
            "CountryName": "Sweden",
            "CountryCode": "SE",
            "CityCode": "120613"
        },
        {
            "CityName": "Harsewinkel",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120614"
        },
        {
            "CityName": "Hart im Zillertal",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "120615"
        },
        {
            "CityName": "Hartlepool",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120616"
        },
        {
            "CityName": "Hartwell",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120617"
        },
        {
            "CityName": "Harvie Heights",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "120618"
        },
        {
            "CityName": "Herzberg am Harz",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120685"
        },
        {
            "CityName": "Harbin",
            "CountryName": "China",
            "CountryCode": "CN",
            "CityCode": "120769"
        },
        {
            "CityName": "Harbke",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120770"
        },
        {
            "CityName": "Harbor City",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120771"
        },
        {
            "CityName": "Harbour Island",
            "CountryName": "Bahamas",
            "CountryCode": "BS",
            "CityCode": "120772"
        },
        {
            "CityName": "Hardegsen",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120773"
        },
        {
            "CityName": "Hardt",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120774"
        },
        {
            "CityName": "Haren",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120775"
        },
        {
            "CityName": "Hari Hari",
            "CountryName": "New Zealand",
            "CountryCode": "NZ",
            "CityCode": "120776"
        },
        {
            "CityName": "Harriman (New York)",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120777"
        },
        {
            "CityName": "Harrington",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "120778"
        },
        {
            "CityName": "Harrisburg",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120779"
        },
        {
            "CityName": "Harrison",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120780"
        },
        {
            "CityName": "Harrison",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120781"
        },
        {
            "CityName": "Harrodsburg",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120782"
        },
        {
            "CityName": "Hartford",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120783"
        },
        {
            "CityName": "Harrisburg",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120863"
        },
        {
            "CityName": "Harrislee",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "120864"
        },
        {
            "CityName": "Harrow",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120865"
        },
        {
            "CityName": "Hartington",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120866"
        },
        {
            "CityName": "Harvey",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "120867"
        },
        {
            "CityName": "Harwich",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "120868"
        },
        {
            "CityName": "Hardin",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121182"
        },
        {
            "CityName": "Hardy",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121183"
        },
        {
            "CityName": "Hareid",
            "CountryName": "Norway",
            "CountryCode": "NO",
            "CityCode": "121184"
        },
        {
            "CityName": "Harel",
            "CountryName": "Israel",
            "CountryCode": "IL",
            "CityCode": "121185"
        },
        {
            "CityName": "Haridwar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "121186"
        },
        {
            "CityName": "Harrachov",
            "CountryName": "Czech Republic",
            "CountryCode": "CZ",
            "CityCode": "121187"
        },
        {
            "CityName": "Harrison Hot Springs",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "121188"
        },
        {
            "CityName": "Harrogate",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "121189"
        },
        {
            "CityName": "Hart bei Graz",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "121190"
        },
        {
            "CityName": "Hartford",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121191"
        },
        {
            "CityName": "Hartha",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "121192"
        },
        {
            "CityName": "Haruchas",
            "CountryName": "Namibia",
            "CountryCode": "NA",
            "CityCode": "121193"
        },
        {
            "CityName": "Indian Harbour Beach",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121612"
        },
        {
            "CityName": "Harvey",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121852"
        },
        {
            "CityName": "Harwich Port",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121853"
        },
        {
            "CityName": "Kalahari",
            "CountryName": "Namibia",
            "CountryCode": "NA",
            "CityCode": "122237"
        },
        {
            "CityName": "Jalandhar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "122327"
        },
        {
            "CityName": "Kashihara",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "122536"
        },
        {
            "CityName": "Decines-Charpieu",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "116276"
        },
        {
            "CityName": "Dutch Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "116465"
        },
        {
            "CityName": "Egg Harbor City",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "116498"
        },
        {
            "CityName": "Ein Harod",
            "CountryName": "Israel",
            "CountryCode": "IL",
            "CityCode": "116513"
        },
        {
            "CityName": "Damouchari",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "116617"
        },
        {
            "CityName": "Eksharad",
            "CountryName": "Sweden",
            "CountryCode": "SE",
            "CityCode": "116764"
        },
        {
            "CityName": "Egg Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "117074"
        },
        {
            "CityName": "Egg Harbor Township",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "117075"
        },
        {
            "CityName": "Engelhartszell",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "117165"
        },
        {
            "CityName": "Elkhart Lake",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "117455"
        },
        {
            "CityName": "Elkhart",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "117788"
        },
        {
            "CityName": "English Harbour",
            "CountryName": "Antigua & Barbuda",
            "CountryCode": "AG",
            "CityCode": "118083"
        },
        {
            "CityName": "Friday Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "118633"
        },
        {
            "CityName": "Gearhart",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "118668"
        },
        {
            "CityName": "Gharb",
            "CountryName": "Malta",
            "CountryCode": "MT",
            "CityCode": "119110"
        },
        {
            "CityName": "Gig Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "119271"
        },
        {
            "CityName": "Ghardaia",
            "CountryName": "Algeria",
            "CountryCode": "DZ",
            "CityCode": "119377"
        },
        {
            "CityName": "Gro?harrie",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "119741"
        },
        {
            "CityName": "Governor's Harbour",
            "CountryName": "Bahamas",
            "CountryCode": "BS",
            "CityCode": "119836"
        },
        {
            "CityName": "Marsh Harbour",
            "CountryName": "Bahamas",
            "CountryCode": "BS",
            "CityCode": "146524"
        },
        {
            "CityName": "Neuhardenberg",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "146848"
        },
        {
            "CityName": "Neve Zohar",
            "CountryName": "Israel",
            "CountryCode": "IL",
            "CityCode": "146861"
        },
        {
            "CityName": "Port Orchard",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "147295"
        },
        {
            "CityName": "Pourcharesses",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "147339"
        },
        {
            "CityName": "Sagamihara",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "147606"
        },
        {
            "CityName": "Saidu Sharif",
            "CountryName": "Pakistan",
            "CountryCode": "PK",
            "CityCode": "147609"
        },
        {
            "CityName": "Sankt Leonhard",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "147723"
        },
        {
            "CityName": "Sharks Bay",
            "CountryName": "Egypt",
            "CountryCode": "EG",
            "CityCode": "147879"
        },
        {
            "CityName": "Shartlesville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "147880"
        },
        {
            "CityName": "Shute Harbour",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "147898"
        },
        {
            "CityName": "St. Charles",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "148002"
        },
        {
            "CityName": "Khartoum",
            "CountryName": "Sudan",
            "CountryCode": "SD",
            "CityCode": "124230"
        },
        {
            "CityName": "Kota Bharu",
            "CountryName": "Malaysia",
            "CountryCode": "MY",
            "CityCode": "124286"
        },
        {
            "CityName": "Laugharne",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "124555"
        },
        {
            "CityName": "Lestelle-Betharram",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "124888"
        },
        {
            "CityName": "Lanchares",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "125199"
        },
        {
            "CityName": "Loch Harray",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "125343"
        },
        {
            "CityName": "Linhares",
            "CountryName": "Brazil",
            "CountryCode": "BR",
            "CityCode": "125451"
        },
        {
            "CityName": "Les Charbonnieres",
            "CountryName": "Switzerland",
            "CountryCode": "CH",
            "CityCode": "125546"
        },
        {
            "CityName": "La Richardais",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "125718"
        },
        {
            "CityName": "Linhares",
            "CountryName": "Portugal",
            "CountryCode": "PT",
            "CityCode": "126024"
        },
        {
            "CityName": "Louis Trichardt",
            "CountryName": "South Africa",
            "CountryCode": "ZA",
            "CityCode": "126046"
        },
        {
            "CityName": "Mainhardt",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "126126"
        },
        {
            "CityName": "Logga  Charani",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "126310"
        },
        {
            "CityName": "Little Harbour",
            "CountryName": "British Virgin Islands",
            "CountryCode": "VG",
            "CityCode": "126582"
        },
        {
            "CityName": "Little Hartley",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "126583"
        },
        {
            "CityName": "Lockhart",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "126615"
        },
        {
            "CityName": "Manhartsbrunn",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "126966"
        },
        {
            "CityName": "Mihara",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "127201"
        },
        {
            "CityName": "Market Harborough",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "127501"
        },
        {
            "CityName": "Meekatharra",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "127562"
        },
        {
            "CityName": "Meinhard",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "127716"
        },
        {
            "CityName": "Mastichari",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "128149"
        },
        {
            "CityName": "Saint-Yrieix-sur-Charente",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "136146"
        },
        {
            "CityName": "Shark Bay",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "136288"
        },
        {
            "CityName": "Sanquhar",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "136508"
        },
        {
            "CityName": "Saulx-les-Chartreux",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "136566"
        },
        {
            "CityName": "Schardenberg",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "136581"
        },
        {
            "CityName": "Scharrachbergheim-Irmstett",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "136665"
        },
        {
            "CityName": "Scharmer",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "136709"
        },
        {
            "CityName": "Shari",
            "CountryName": "Japan",
            "CountryCode": "JP",
            "CityCode": "136796"
        },
        {
            "CityName": "Sharm el Sheikh",
            "CountryName": "Egypt",
            "CountryCode": "EG",
            "CityCode": "136797"
        },
        {
            "CityName": "Scharbeutz",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "136928"
        },
        {
            "CityName": "Scharding",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "136929"
        },
        {
            "CityName": "Scharnitz",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "136930"
        },
        {
            "CityName": "Scharzfeld",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "136931"
        },
        {
            "CityName": "Southwest Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "137101"
        },
        {
            "CityName": "Schoharie",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "137228"
        },
        {
            "CityName": "Schulenberg im Oberharz",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "137231"
        },
        {
            "CityName": "Sharon",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "137301"
        },
        {
            "CityName": "Sharon Springs",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "137386"
        },
        {
            "CityName": "Sharonville",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "137570"
        },
        {
            "CityName": "Sharjah",
            "CountryName": "United Arab Emirates",
            "CountryCode": "AE",
            "CityCode": "137741"
        },
        {
            "CityName": "Sharm el Naga",
            "CountryName": "Egypt",
            "CountryCode": "EG",
            "CityCode": "137742"
        },
        {
            "CityName": "St. Leonhard",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "137781"
        },
        {
            "CityName": "Straubenhardt",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "137847"
        },
        {
            "CityName": "St. Marienkirchen bei Scharding",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "138233"
        },
        {
            "CityName": "St. Catharines",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "138376"
        },
        {
            "CityName": "St. Charles",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "138378"
        },
        {
            "CityName": "Slagharen",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "138454"
        },
        {
            "CityName": "Sohar",
            "CountryName": "Oman",
            "CountryCode": "OM",
            "CityCode": "138467"
        },
        {
            "CityName": "Pharr",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "132154"
        },
        {
            "CityName": "Pokhara",
            "CountryName": "Nepal",
            "CountryCode": "NP",
            "CityCode": "132362"
        },
        {
            "CityName": "Port Charles",
            "CountryName": "New Zealand",
            "CountryCode": "NZ",
            "CityCode": "132391"
        },
        {
            "CityName": "Port Harcourt",
            "CountryName": "Nigeria",
            "CountryCode": "NG",
            "CityCode": "132395"
        },
        {
            "CityName": "Penchard",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "132447"
        },
        {
            "CityName": "Punkaharju",
            "CountryName": "Finland",
            "CountryCode": "FI",
            "CityCode": "132584"
        },
        {
            "CityName": "Qiqihar",
            "CountryName": "China",
            "CountryCode": "CN",
            "CityCode": "133149"
        },
        {
            "CityName": "Pohara",
            "CountryName": "New Zealand",
            "CountryCode": "NZ",
            "CityCode": "133207"
        },
        {
            "CityName": "Pool-in-Wharfedale",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "133496"
        },
        {
            "CityName": "Port Charlotte",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "133502"
        },
        {
            "CityName": "Port Charlotte",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "133557"
        },
        {
            "CityName": "Queen Charlotte",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "133653"
        },
        {
            "CityName": "Redenhall with Harleston",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "133868"
        },
        {
            "CityName": "Sag Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "134121"
        },
        {
            "CityName": "Saint-Doulchard",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "134146"
        },
        {
            "CityName": "Port Hardy",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "134269"
        },
        {
            "CityName": "Richards Bay",
            "CountryName": "South Africa",
            "CountryCode": "ZA",
            "CityCode": "134389"
        },
        {
            "CityName": "Richardson",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "134390"
        },
        {
            "CityName": "Riegersburg / Hardegg",
            "CountryName": "Austria",
            "CountryCode": "AT",
            "CityCode": "134399"
        },
        {
            "CityName": "Roche Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "134516"
        },
        {
            "CityName": "Red Wharf Bay",
            "CountryName": "United Kingdom",
            "CountryCode": "GB",
            "CityCode": "134724"
        },
        {
            "CityName": "Rocky Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "134952"
        },
        {
            "CityName": "Safety Harbour",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "135017"
        },
        {
            "CityName": "Reinhardtsdorf-Schona",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "135075"
        },
        {
            "CityName": "Reischenhart",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "135077"
        },
        {
            "CityName": "Saint-Martin-aux-Chartrains",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "135221"
        },
        {
            "CityName": "Saint-Hilaire-du-Harcouet",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "135347"
        },
        {
            "CityName": "Sackets Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "135487"
        },
        {
            "CityName": "Saint Charles",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "135496"
        },
        {
            "CityName": "Scharendijke",
            "CountryName": "Netherlands",
            "CountryCode": "NL",
            "CityCode": "135613"
        },
        {
            "CityName": "Stone Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "140200"
        },
        {
            "CityName": "Szentgotthard",
            "CountryName": "Hungary",
            "CountryCode": "HU",
            "CityCode": "140263"
        },
        {
            "CityName": "Tissamaharama",
            "CountryName": "Sri Lanka",
            "CountryCode": "LK",
            "CityCode": "140450"
        },
        {
            "CityName": "Two Harbors",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "140685"
        },
        {
            "CityName": "Thury-Harcourt",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "140756"
        },
        {
            "CityName": "Victor Harbor",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "142319"
        },
        {
            "CityName": "Zacharo",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "142477"
        },
        {
            "CityName": "Zahara de la Sierra",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "142478"
        },
        {
            "CityName": "Wharton",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "142684"
        },
        {
            "CityName": "Young Harris",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "142919"
        },
        {
            "CityName": "West Harwich",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "142971"
        },
        {
            "CityName": "Winthrop Harbor",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "143037"
        },
        {
            "CityName": "Wuste Thar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "143481"
        },
        {
            "CityName": "Zell am Harmersbach",
            "CountryName": "Germany",
            "CountryCode": "DE",
            "CityCode": "143669"
        },
        {
            "CityName": "Zahara de los Atunes",
            "CountryName": "Spain",
            "CountryCode": "ES",
            "CityCode": "143819"
        },
        {
            "CityName": "Zohar Hot Springs",
            "CountryName": "Israel",
            "CountryCode": "IL",
            "CityCode": "143850"
        },
        {
            "CityName": "Zachary",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "143911"
        },
        {
            "CityName": "Tonnay-Charente",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "148260"
        },
        {
            "CityName": "Uhart-Cize",
            "CountryName": "France",
            "CountryCode": "FR",
            "CityCode": "148365"
        },
        {
            "CityName": "Chakcharan",
            "CountryName": "Afghanistan",
            "CountryCode": "AF",
            "CityCode": "148839"
        },
        {
            "CityName": "Kharkhorin",
            "CountryName": "Mongolia",
            "CountryCode": "MN",
            "CityCode": "149130"
        },
        {
            "CityName": "Intu Afrika Kalahari Private Reserve",
            "CountryName": "Namibia",
            "CountryCode": "NA",
            "CityCode": "149217"
        },
        {
            "CityName": "Chaurjhari",
            "CountryName": "Nepal",
            "CountryCode": "NP",
            "CityCode": "149242"
        },
        {
            "CityName": "Richard-Toll",
            "CountryName": "Senegal",
            "CountryCode": "SN",
            "CityCode": "149515"
        },
        {
            "CityName": "Bechar",
            "CountryName": "Algeria",
            "CountryCode": "DZ",
            "CityCode": "149604"
        },
        {
            "CityName": "El Kharga",
            "CountryName": "Egypt",
            "CountryCode": "EG",
            "CityCode": "149649"
        },
        {
            "CityName": "Haruru",
            "CountryName": "New Zealand",
            "CountryCode": "NZ",
            "CityCode": "150204"
        },
        {
            "CityName": "Silchar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "150361"
        },
        {
            "CityName": "Kandahar",
            "CountryName": "Afghanistan",
            "CountryCode": "AF",
            "CityCode": "150371"
        },
        {
            "CityName": "Mazar I Sharif",
            "CountryName": "Afghanistan",
            "CountryCode": "AF",
            "CityCode": "150377"
        },
        {
            "CityName": "Charlo",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "150434"
        },
        {
            "CityName": "Bharatpur",
            "CountryName": "Nepal",
            "CountryCode": "NP",
            "CityCode": "150482"
        },
        {
            "CityName": "Sachs Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "150674"
        },
        {
            "CityName": "Sharurah",
            "CountryName": "Saudi Arabia",
            "CountryCode": "SA",
            "CityCode": "150939"
        },
        {
            "CityName": "Hartley Bay",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "151004"
        },
        {
            "CityName": "Thargomindah",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "151031"
        },
        {
            "CityName": "Coral Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "151079"
        },
        {
            "CityName": "Kailashahar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "151112"
        },
        {
            "CityName": "Mary's Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "151280"
        },
        {
            "CityName": "Fox Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "151448"
        },
        {
            "CityName": "Lockhart River",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "151479"
        },
        {
            "CityName": "Williams Harbour",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "151690"
        },
        {
            "CityName": "Garbaharey",
            "CountryName": "Somalia",
            "CountryCode": "SO",
            "CityCode": "151749"
        },
        {
            "CityName": "Hargeisa",
            "CountryName": "Somalia",
            "CountryCode": "SO",
            "CityCode": "151752"
        },
        {
            "CityName": "Nawanshahar",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "151846"
        },
        {
            "CityName": "Delhi",
            "CountryName": "Canada",
            "CountryCode": "CA",
            "CityCode": "105477"
        },
        {
            "CityName": "Delhi",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "116067"
        },
        {
            "CityName": "Delhi",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "130443"
        },
        {
            "CityName": "Mumbai",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "128734"
        },
        {
            "CityName": "Hyden",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "122657"
        },
        {
            "CityName": "Hyderabad",
            "CountryName": "India",
            "CountryCode": "IN",
            "CityCode": "145710"
        },
        {
            "CityName": "Hyder",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121042"
        },
        {
            "CityName": "Hyde Park",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "121439"
        },
        {
            "CityName": "Hyde Park",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "122091"
        },
        {
            "CityName": "Hydra Town",
            "CountryName": "Greece",
            "CountryCode": "GR",
            "CityCode": "122092"
        },
        {
            "CityName": "Maroochydore",
            "CountryName": "Australia",
            "CountryCode": "AU",
            "CityCode": "127008"
        },
        {
            "CityName": "Hyderabad",
            "CountryName": "Pakistan",
            "CountryCode": "PK",
            "CityCode": "149275"
        },
        {
            "CityName": "Hydaburg",
            "CountryName": "United States of America",
            "CountryCode": "US",
            "CityCode": "150526"
        }
    ]

export const popularHotelCities = [
    {
        "id": "29381",
        "tboCityId": "130443",
        "tripjack_city_id": "725862",
        "tboCountryCode": "IN",
        "state": "DELHI",
        "countryName": "India",
        "type": "CITY",
        "name": "Delhi",
        "cityName": "Delhi",
        "fullRegionName": "INDIA",
        "countryId": "106",
        "source": "city"
    },
    {
        "id": "29212",
        "tboCityId": "144306",
        "tripjack_city_id": "699261",
        "tboCountryCode": "IN",
        "state": "Maharashtra",
        "countryName": "INDIA",
        "type": "CITY",
        "name": "MUMBAI",
        "cityName": "MUMBAI",
        "fullRegionName": "MUMBAI, MAHARASHTRA, INDIA",
        "countryId": "106",
        "source": "city"
    },
    {
        "id": "19231",
        "tboCityId": "115936",
        "tripjack_city_id": "147862",
        "tboCountryCode": "AE",
        "state": "",
        "countryName": "UNITED ARAB EMIRATES",
        "type": "CITY",
        "name": "DUBAI",
        "cityName": "DUBAI",
        "fullRegionName": "DUBAI, DUBAI, UNITED ARAB EMIRATES",
        "countryId": "138",
        "source": "city"
    },
    {
        "id": "29154",
        "tboCityId": "113128",
        "tripjack_city_id": "739947",
        "tboCountryCode": "IN",
        "state": "West Bengal",
        "countryName": "INDIA",
        "type": "CITY",
        "name": "KOLKATA",
        "cityName": "KOLKATA",
        "fullRegionName": "KOLKATA, WEST BENGAL, INDIA",
        "countryId": "106",
        "source": "city"
    },
    {
        "id": "28874",
        "tboCityId": "145710",
        "tripjack_city_id": "739424",
        "tboCountryCode": "IN",
        "state": "Andra Pradesh",
        "countryName": "INDIA",
        "type": "CITY",
        "name": "HYDERABAD",
        "cityName": "HYDERABAD",
        "fullRegionName": "HYDERABAD, TELANGANA, INDIA",
        "countryId": "106",
        "source": "city"
    },
    {
        "id": "29224",
        "tboCityId": "111124",
        "tripjack_city_id": "697302",
        "tboCountryCode": "IN",
        "state": "Karnataka",
        "countryName": "INDIA",
        "type": "CITY",
        "name": "BENGALURU",
        "cityName": "BENGALURU",
        "fullRegionName": "BENGALURU, KARNATAKA, INDIA",
        "countryId": "106",
        "source": "city"
    },
    {
        "id": "18753",
        "tboCityId": "146788",
        "tripjack_city_id": "738765",
        "tboCountryCode": "OM",
        "state": "",
        "countryName": "OMAN",
        "type": "CITY",
        "name": "MUSCAT",
        "cityName": "MUSCAT",
        "fullRegionName": "MUSCAT, MUSCAT GOVERNORATE, OMAN",
        "countryId": "125",
        "source": "city"
    },
    {
        "id": "15086",
        "tboCityId": "126388",
        "tripjack_city_id": "656671",
        "tboCountryCode": "IN",
        "state": "Himachal pradesh",
        "countryName": "INDIA",
        "type": "CITY",
        "name": "MANALI",
        "cityName": "MANALI",
        "fullRegionName": "MANALI, HIMACHAL PRADESH, INDIA",
        "countryId": "106",
        "source": "city"
    },
    {
        "id": "19994",
        "tboCityId": "119805",
        "tripjack_city_id": "699356",
        "tboCountryCode": "IN",
        "state": "GOA",
        "countryName": "INDIA",
        "type": "PROVINCE_STATE",
        "name": "GOA",
        "cityName": "GOA",
        "fullRegionName": "GOA, INDIA",
        "countryId": "106",
        "source": "city"
    }
]

export const topTanCity = [
    {
        "flight_country": "India",
        "id": 1892,
        "code": "DEL",
        "name": "Delhi Indira Gandhi Intl",
        "cityCode": "DEL",
        "city": "Delhi",
        "countryCode": "IN"
    },
    {
        "flight_country": "India",
        "id": 1881,
        "code": "BOM",
        "name": "Chhatrapati Shivaji",
        "cityCode": "BOM",
        "city": "Mumbai",
        "countryCode": "IN"
    },
    {
        "flight_country": "United Arab Emirates",
        "id": 3517,
        "code": "XNB",
        "name": "Dubai Chelsea Tower Bus Station",
        "cityCode": "DXB",
        "city": "Dubai",
        "countryCode": "AE"
    },
    {
        "flight_country": "India",
        "id": 1886,
        "code": "CCU",
        "name": "Netaji Subhas Chandra Bose Intl",
        "cityCode": "CCU",
        "city": "Kolkata",
        "countryCode": "IN"
    },
    {
        "flight_country": "Thailand",
        "id": 3400,
        "code": "BKK",
        "name": "Suvarnabhumi Intl Arpt",
        "cityCode": "BKK",
        "city": "Bangkok",
        "countryCode": "TH"
    },
    {
        "flight_country": "Singapore",
        "id": 3088,
        "code": "XSP",
        "name": "Seletar Airport",
        "cityCode": "SIN",
        "city": "Singapore",
        "countryCode": "SG"
    },
    {
        "flight_country": "India",
        "id": 1851,
        "code": "MAA",
        "name": "Chennai Arpt",
        "cityCode": "MAA",
        "city": "Chennai",
        "countryCode": "IN"
    },
    {
        "flight_country": "India",
        "id": 1870,
        "code": "HYD",
        "name": "Shamshabad Rajiv Gandhi Intl Arpt",
        "cityCode": "HYD",
        "city": "Hyderabad",
        "countryCode": "IN"
    },
    {
        "flight_country": "India",
        "id": 1872,
        "code": "GOI",
        "name": "Dabolim Arpt",
        "cityCode": "GOI",
        "city": "Goa In",
        "countryCode": "IN"
    },
    {
        "flight_country": "Nepal",
        "id": 2549,
        "code": "KTM",
        "name": "Tribuvan Arpt",
        "cityCode": "KTM",
        "city": "Kathmandu",
        "countryCode": "NP"
    }
];

export const getfilteredCountries = [

    {
        "name": "Afghanistan",
        "dial_code": "+93",
        "code": "AF"
    },
    {
        "name": "Aland Islands",
        "dial_code": "+358",
        "code": "AX"
    },
    {
        "name": "Albania",
        "dial_code": "+355",
        "code": "AL"
    },
    {
        "name": "Algeria",
        "dial_code": "+213",
        "code": "DZ"
    },
    {
        "name": "AmericanSamoa",
        "dial_code": "+1684",
        "code": "AS"
    },
    {
        "name": "Andorra",
        "dial_code": "+376",
        "code": "AD"
    },
    {
        "name": "Angola",
        "dial_code": "+244",
        "code": "AO"
    },
    {
        "name": "Anguilla",
        "dial_code": "+1264",
        "code": "AI"
    },
    {
        "name": "Antarctica",
        "dial_code": "+672",
        "code": "AQ"
    },
    {
        "name": "Antigua and Barbuda",
        "dial_code": "+1268",
        "code": "AG"
    },
    {
        "name": "Argentina",
        "dial_code": "+54",
        "code": "AR"
    },
    {
        "name": "Armenia",
        "dial_code": "+374",
        "code": "AM"
    },
    {
        "name": "Aruba",
        "dial_code": "+297",
        "code": "AW"
    },
    {
        "name": "Australia",
        "dial_code": "+61",
        "code": "AU"
    },
    {
        "name": "Austria",
        "dial_code": "+43",
        "code": "AT"
    },
    {
        "name": "Azerbaijan",
        "dial_code": "+994",
        "code": "AZ"
    },
    {
        "name": "Bahamas",
        "dial_code": "+1242",
        "code": "BS"
    },
    {
        "name": "Bahrain",
        "dial_code": "+973",
        "code": "BH"
    },
    {
        "name": "Bangladesh",
        "dial_code": "+880",
        "code": "BD"
    },
    {
        "name": "Barbados",
        "dial_code": "+1246",
        "code": "BB"
    },
    {
        "name": "Belarus",
        "dial_code": "+375",
        "code": "BY"
    },
    {
        "name": "Belgium",
        "dial_code": "+32",
        "code": "BE"
    },
    {
        "name": "Belize",
        "dial_code": "+501",
        "code": "BZ"
    },
    {
        "name": "Benin",
        "dial_code": "+229",
        "code": "BJ"
    },
    {
        "name": "Bermuda",
        "dial_code": "+1441",
        "code": "BM"
    },
    {
        "name": "Bhutan",
        "dial_code": "+975",
        "code": "BT"
    },
    {
        "name": "Bolivia, Plurinational State of",
        "dial_code": "+591",
        "code": "BO"
    },
    {
        "name": "Bosnia and Herzegovina",
        "dial_code": "+387",
        "code": "BA"
    },
    {
        "name": "Botswana",
        "dial_code": "+267",
        "code": "BW"
    },
    {
        "name": "Brazil",
        "dial_code": "+55",
        "code": "BR"
    },
    {
        "name": "British Indian Ocean Territory",
        "dial_code": "+246",
        "code": "IO"
    },
    {
        "name": "Brunei Darussalam",
        "dial_code": "+673",
        "code": "BN"
    },
    {
        "name": "Bulgaria",
        "dial_code": "+359",
        "code": "BG"
    },
    {
        "name": "Burkina Faso",
        "dial_code": "+226",
        "code": "BF"
    },
    {
        "name": "Burundi",
        "dial_code": "+257",
        "code": "BI"
    },
    {
        "name": "Cambodia",
        "dial_code": "+855",
        "code": "KH"
    },
    {
        "name": "Cameroon",
        "dial_code": "+237",
        "code": "CM"
    },
    {
        "name": "Canada",
        "dial_code": "+1",
        "code": "CA"
    },
    {
        "name": "Cape Verde",
        "dial_code": "+238",
        "code": "CV"
    },
    {
        "name": "Cayman Islands",
        "dial_code": "+ 345",
        "code": "KY"
    },
    {
        "name": "Central African Republic",
        "dial_code": "+236",
        "code": "CF"
    },
    {
        "name": "Chad",
        "dial_code": "+235",
        "code": "TD"
    },
    {
        "name": "Chile",
        "dial_code": "+56",
        "code": "CL"
    },
    {
        "name": "China",
        "dial_code": "+86",
        "code": "CN"
    },
    {
        "name": "Christmas Island",
        "dial_code": "+61",
        "code": "CX"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "dial_code": "+61",
        "code": "CC"
    },
    {
        "name": "Colombia",
        "dial_code": "+57",
        "code": "CO"
    },
    {
        "name": "Comoros",
        "dial_code": "+269",
        "code": "KM"
    },
    {
        "name": "Congo",
        "dial_code": "+242",
        "code": "CG"
    },
    {
        "name": "Congo, The Democratic Republic of the Congo",
        "dial_code": "+243",
        "code": "CD"
    },
    {
        "name": "Cook Islands",
        "dial_code": "+682",
        "code": "CK"
    },
    {
        "name": "Costa Rica",
        "dial_code": "+506",
        "code": "CR"
    },
    {
        "name": "Cote d'Ivoire",
        "dial_code": "+225",
        "code": "CI"
    },
    {
        "name": "Croatia",
        "dial_code": "+385",
        "code": "HR"
    },
    {
        "name": "Cuba",
        "dial_code": "+53",
        "code": "CU"
    },
    {
        "name": "Cyprus",
        "dial_code": "+357",
        "code": "CY"
    },
    {
        "name": "Czech Republic",
        "dial_code": "+420",
        "code": "CZ"
    },
    {
        "name": "Denmark",
        "dial_code": "+45",
        "code": "DK"
    },
    {
        "name": "Djibouti",
        "dial_code": "+253",
        "code": "DJ"
    },
    {
        "name": "Dominica",
        "dial_code": "+1767",
        "code": "DM"
    },
    {
        "name": "Dominican Republic",
        "dial_code": "+1849",
        "code": "DO"
    },
    {
        "name": "Ecuador",
        "dial_code": "+593",
        "code": "EC"
    },
    {
        "name": "Egypt",
        "dial_code": "+20",
        "code": "EG"
    },
    {
        "name": "El Salvador",
        "dial_code": "+503",
        "code": "SV"
    },
    {
        "name": "Equatorial Guinea",
        "dial_code": "+240",
        "code": "GQ"
    },
    {
        "name": "Eritrea",
        "dial_code": "+291",
        "code": "ER"
    },
    {
        "name": "Estonia",
        "dial_code": "+372",
        "code": "EE"
    },
    {
        "name": "Ethiopia",
        "dial_code": "+251",
        "code": "ET"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "dial_code": "+500",
        "code": "FK"
    },
    {
        "name": "Faroe Islands",
        "dial_code": "+298",
        "code": "FO"
    },
    {
        "name": "Fiji",
        "dial_code": "+679",
        "code": "FJ"
    },
    {
        "name": "Finland",
        "dial_code": "+358",
        "code": "FI"
    },
    {
        "name": "France",
        "dial_code": "+33",
        "code": "FR"
    },
    {
        "name": "French Guiana",
        "dial_code": "+594",
        "code": "GF"
    },
    {
        "name": "French Polynesia",
        "dial_code": "+689",
        "code": "PF"
    },
    {
        "name": "Gabon",
        "dial_code": "+241",
        "code": "GA"
    },
    {
        "name": "Gambia",
        "dial_code": "+220",
        "code": "GM"
    },
    {
        "name": "Georgia",
        "dial_code": "+995",
        "code": "GE"
    },
    {
        "name": "Germany",
        "dial_code": "+49",
        "code": "DE"
    },
    {
        "name": "Ghana",
        "dial_code": "+233",
        "code": "GH"
    },
    {
        "name": "Gibraltar",
        "dial_code": "+350",
        "code": "GI"
    },
    {
        "name": "Greece",
        "dial_code": "+30",
        "code": "GR"
    },
    {
        "name": "Greenland",
        "dial_code": "+299",
        "code": "GL"
    },
    {
        "name": "Grenada",
        "dial_code": "+1473",
        "code": "GD"
    },
    {
        "name": "Guadeloupe",
        "dial_code": "+590",
        "code": "GP"
    },
    {
        "name": "Guam",
        "dial_code": "+1671",
        "code": "GU"
    },
    {
        "name": "Guatemala",
        "dial_code": "+502",
        "code": "GT"
    },
    {
        "name": "Guernsey",
        "dial_code": "+44",
        "code": "GG"
    },
    {
        "name": "Guinea",
        "dial_code": "+224",
        "code": "GN"
    },
    {
        "name": "Guinea-Bissau",
        "dial_code": "+245",
        "code": "GW"
    },
    {
        "name": "Guyana",
        "dial_code": "+595",
        "code": "GY"
    },
    {
        "name": "Haiti",
        "dial_code": "+509",
        "code": "HT"
    },
    {
        "name": "Holy See (Vatican City State)",
        "dial_code": "+379",
        "code": "VA"
    },
    {
        "name": "Honduras",
        "dial_code": "+504",
        "code": "HN"
    },
    {
        "name": "Hong Kong",
        "dial_code": "+852",
        "code": "HK"
    },
    {
        "name": "Hungary",
        "dial_code": "+36",
        "code": "HU"
    },
    {
        "name": "Iceland",
        "dial_code": "+354",
        "code": "IS"
    },
    {
        "name": "India",
        "dial_code": "+91",
        "code": "IN"
    },
    {
        "name": "Indonesia",
        "dial_code": "+62",
        "code": "ID"
    },
    {
        "name": "Iran, Islamic Republic of Persian Gulf",
        "dial_code": "+98",
        "code": "IR"
    },
    {
        "name": "Iraq",
        "dial_code": "+964",
        "code": "IQ"
    },
    {
        "name": "Ireland",
        "dial_code": "+353",
        "code": "IE"
    },
    {
        "name": "Isle of Man",
        "dial_code": "+44",
        "code": "IM"
    },
    {
        "name": "Israel",
        "dial_code": "+972",
        "code": "IL"
    },
    {
        "name": "Italy",
        "dial_code": "+39",
        "code": "IT"
    },
    {
        "name": "Jamaica",
        "dial_code": "+1876",
        "code": "JM"
    },
    {
        "name": "Japan",
        "dial_code": "+81",
        "code": "JP"
    },
    {
        "name": "Jersey",
        "dial_code": "+44",
        "code": "JE"
    },
    {
        "name": "Jordan",
        "dial_code": "+962",
        "code": "JO"
    },
    {
        "name": "Kazakhstan",
        "dial_code": "+77",
        "code": "KZ"
    },
    {
        "name": "Kenya",
        "dial_code": "+254",
        "code": "KE"
    },
    {
        "name": "Kiribati",
        "dial_code": "+686",
        "code": "KI"
    },
    {
        "name": "Korea, Democratic People's Republic of Korea",
        "dial_code": "+850",
        "code": "KP"
    },
    {
        "name": "Korea, Republic of South Korea",
        "dial_code": "+82",
        "code": "KR"
    },
    {
        "name": "Kuwait",
        "dial_code": "+965",
        "code": "KW"
    },
    {
        "name": "Kyrgyzstan",
        "dial_code": "+996",
        "code": "KG"
    },
    {
        "name": "Laos",
        "dial_code": "+856",
        "code": "LA"
    },
    {
        "name": "Latvia",
        "dial_code": "+371",
        "code": "LV"
    },
    {
        "name": "Lebanon",
        "dial_code": "+961",
        "code": "LB"
    },
    {
        "name": "Lesotho",
        "dial_code": "+266",
        "code": "LS"
    },
    {
        "name": "Liberia",
        "dial_code": "+231",
        "code": "LR"
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "dial_code": "+218",
        "code": "LY"
    },
    {
        "name": "Liechtenstein",
        "dial_code": "+423",
        "code": "LI"
    },
    {
        "name": "Lithuania",
        "dial_code": "+370",
        "code": "LT"
    },
    {
        "name": "Luxembourg",
        "dial_code": "+352",
        "code": "LU"
    },
    {
        "name": "Macao",
        "dial_code": "+853",
        "code": "MO"
    },
    {
        "name": "Macedonia",
        "dial_code": "+389",
        "code": "MK"
    },
    {
        "name": "Madagascar",
        "dial_code": "+261",
        "code": "MG"
    },
    {
        "name": "Malawi",
        "dial_code": "+265",
        "code": "MW"
    },
    {
        "name": "Malaysia",
        "dial_code": "+60",
        "code": "MY"
    },
    {
        "name": "Maldives",
        "dial_code": "+960",
        "code": "MV"
    },
    {
        "name": "Mali",
        "dial_code": "+223",
        "code": "ML"
    },
    {
        "name": "Malta",
        "dial_code": "+356",
        "code": "MT"
    },
    {
        "name": "Marshall Islands",
        "dial_code": "+692",
        "code": "MH"
    },
    {
        "name": "Martinique",
        "dial_code": "+596",
        "code": "MQ"
    },
    {
        "name": "Mauritania",
        "dial_code": "+222",
        "code": "MR"
    },
    {
        "name": "Mauritius",
        "dial_code": "+230",
        "code": "MU"
    },
    {
        "name": "Mayotte",
        "dial_code": "+262",
        "code": "YT"
    },
    {
        "name": "Mexico",
        "dial_code": "+52",
        "code": "MX"
    },
    {
        "name": "Micronesia, Federated States of Micronesia",
        "dial_code": "+691",
        "code": "FM"
    },
    {
        "name": "Moldova",
        "dial_code": "+373",
        "code": "MD"
    },
    {
        "name": "Monaco",
        "dial_code": "+377",
        "code": "MC"
    },
    {
        "name": "Mongolia",
        "dial_code": "+976",
        "code": "MN"
    },
    {
        "name": "Montenegro",
        "dial_code": "+382",
        "code": "ME"
    },
    {
        "name": "Montserrat",
        "dial_code": "+1664",
        "code": "MS"
    },
    {
        "name": "Morocco",
        "dial_code": "+212",
        "code": "MA"
    },
    {
        "name": "Mozambique",
        "dial_code": "+258",
        "code": "MZ"
    },
    {
        "name": "Myanmar",
        "dial_code": "+95",
        "code": "MM"
    },
    {
        "name": "Namibia",
        "dial_code": "+264",
        "code": "NA"
    },
    {
        "name": "Nauru",
        "dial_code": "+674",
        "code": "NR"
    },
    {
        "name": "Nepal",
        "dial_code": "+977",
        "code": "NP"
    },
    {
        "name": "Netherlands",
        "dial_code": "+31",
        "code": "NL"
    },
    {
        "name": "Netherlands Antilles",
        "dial_code": "+599",
        "code": "AN"
    },
    {
        "name": "New Caledonia",
        "dial_code": "+687",
        "code": "NC"
    },
    {
        "name": "New Zealand",
        "dial_code": "+64",
        "code": "NZ"
    },
    {
        "name": "Nicaragua",
        "dial_code": "+505",
        "code": "NI"
    },
    {
        "name": "Niger",
        "dial_code": "+227",
        "code": "NE"
    },
    {
        "name": "Nigeria",
        "dial_code": "+234",
        "code": "NG"
    },
    {
        "name": "Niue",
        "dial_code": "+683",
        "code": "NU"
    },
    {
        "name": "Norfolk Island",
        "dial_code": "+672",
        "code": "NF"
    },
    {
        "name": "Northern Mariana Islands",
        "dial_code": "+1670",
        "code": "MP"
    },
    {
        "name": "Norway",
        "dial_code": "+47",
        "code": "NO"
    },
    {
        "name": "Oman",
        "dial_code": "+968",
        "code": "OM"
    },
    {
        "name": "Pakistan",
        "dial_code": "+92",
        "code": "PK"
    },
    {
        "name": "Palau",
        "dial_code": "+680",
        "code": "PW"
    },
    {
        "name": "Palestinian Territory, Occupied",
        "dial_code": "+970",
        "code": "PS"
    },
    {
        "name": "Panama",
        "dial_code": "+507",
        "code": "PA"
    },
    {
        "name": "Papua New Guinea",
        "dial_code": "+675",
        "code": "PG"
    },
    {
        "name": "Paraguay",
        "dial_code": "+595",
        "code": "PY"
    },
    {
        "name": "Peru",
        "dial_code": "+51",
        "code": "PE"
    },
    {
        "name": "Philippines",
        "dial_code": "+63",
        "code": "PH"
    },
    {
        "name": "Pitcairn",
        "dial_code": "+872",
        "code": "PN"
    },
    {
        "name": "Poland",
        "dial_code": "+48",
        "code": "PL"
    },
    {
        "name": "Portugal",
        "dial_code": "+351",
        "code": "PT"
    },
    {
        "name": "Puerto Rico",
        "dial_code": "+1939",
        "code": "PR"
    },
    {
        "name": "Qatar",
        "dial_code": "+974",
        "code": "QA"
    },
    {
        "name": "Romania",
        "dial_code": "+40",
        "code": "RO"
    },
    {
        "name": "Russia",
        "dial_code": "+7",
        "code": "RU"
    },
    {
        "name": "Rwanda",
        "dial_code": "+250",
        "code": "RW"
    },
    {
        "name": "Reunion",
        "dial_code": "+262",
        "code": "RE"
    },
    {
        "name": "Saint Barthelemy",
        "dial_code": "+590",
        "code": "BL"
    },
    {
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "dial_code": "+290",
        "code": "SH"
    },
    {
        "name": "Saint Kitts and Nevis",
        "dial_code": "+1869",
        "code": "KN"
    },
    {
        "name": "Saint Lucia",
        "dial_code": "+1758",
        "code": "LC"
    },
    {
        "name": "Saint Martin",
        "dial_code": "+590",
        "code": "MF"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "dial_code": "+508",
        "code": "PM"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "dial_code": "+1784",
        "code": "VC"
    },
    {
        "name": "Samoa",
        "dial_code": "+685",
        "code": "WS"
    },
    {
        "name": "San Marino",
        "dial_code": "+378",
        "code": "SM"
    },
    {
        "name": "Sao Tome and Principe",
        "dial_code": "+239",
        "code": "ST"
    },
    {
        "name": "Saudi Arabia",
        "dial_code": "+966",
        "code": "SA"
    },
    {
        "name": "Senegal",
        "dial_code": "+221",
        "code": "SN"
    },
    {
        "name": "Serbia",
        "dial_code": "+381",
        "code": "RS"
    },
    {
        "name": "Seychelles",
        "dial_code": "+248",
        "code": "SC"
    },
    {
        "name": "Sierra Leone",
        "dial_code": "+232",
        "code": "SL"
    },
    {
        "name": "Singapore",
        "dial_code": "+65",
        "code": "SG"
    },
    {
        "name": "Slovakia",
        "dial_code": "+421",
        "code": "SK"
    },
    {
        "name": "Slovenia",
        "dial_code": "+386",
        "code": "SI"
    },
    {
        "name": "Solomon Islands",
        "dial_code": "+677",
        "code": "SB"
    },
    {
        "name": "Somalia",
        "dial_code": "+252",
        "code": "SO"
    },
    {
        "name": "South Africa",
        "dial_code": "+27",
        "code": "ZA"
    },
    {
        "name": "South Sudan",
        "dial_code": "+211",
        "code": "SS"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "dial_code": "+500",
        "code": "GS"
    },
    {
        "name": "Spain",
        "dial_code": "+34",
        "code": "ES"
    },
    {
        "name": "Sri Lanka",
        "dial_code": "+94",
        "code": "LK"
    },
    {
        "name": "Sudan",
        "dial_code": "+249",
        "code": "SD"
    },
    {
        "name": "Suriname",
        "dial_code": "+597",
        "code": "SR"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "dial_code": "+47",
        "code": "SJ"
    },
    {
        "name": "Swaziland",
        "dial_code": "+268",
        "code": "SZ"
    },
    {
        "name": "Sweden",
        "dial_code": "+46",
        "code": "SE"
    },
    {
        "name": "Switzerland",
        "dial_code": "+41",
        "code": "CH"
    },
    {
        "name": "Syrian Arab Republic",
        "dial_code": "+963",
        "code": "SY"
    },
    {
        "name": "Taiwan",
        "dial_code": "+886",
        "code": "TW"
    },
    {
        "name": "Tajikistan",
        "dial_code": "+992",
        "code": "TJ"
    },
    {
        "name": "Tanzania, United Republic of Tanzania",
        "dial_code": "+255",
        "code": "TZ"
    },
    {
        "name": "Thailand",
        "dial_code": "+66",
        "code": "TH"
    },
    {
        "name": "Timor-Leste",
        "dial_code": "+670",
        "code": "TL"
    },
    {
        "name": "Togo",
        "dial_code": "+228",
        "code": "TG"
    },
    {
        "name": "Tokelau",
        "dial_code": "+690",
        "code": "TK"
    },
    {
        "name": "Tonga",
        "dial_code": "+676",
        "code": "TO"
    },
    {
        "name": "Trinidad and Tobago",
        "dial_code": "+1868",
        "code": "TT"
    },
    {
        "name": "Tunisia",
        "dial_code": "+216",
        "code": "TN"
    },
    {
        "name": "Turkey",
        "dial_code": "+90",
        "code": "TR"
    },
    {
        "name": "Turkmenistan",
        "dial_code": "+993",
        "code": "TM"
    },
    {
        "name": "Turks and Caicos Islands",
        "dial_code": "+1649",
        "code": "TC"
    },
    {
        "name": "Tuvalu",
        "dial_code": "+688",
        "code": "TV"
    },
    {
        "name": "Uganda",
        "dial_code": "+256",
        "code": "UG"
    },
    {
        "name": "Ukraine",
        "dial_code": "+380",
        "code": "UA"
    },
    {
        "name": "United Arab Emirates",
        "dial_code": "+971",
        "code": "AE"
    },
    {
        "name": "United Kingdom",
        "dial_code": "+44",
        "code": "GB"
    },
    {
        "name": "United States",
        "dial_code": "+1",
        "code": "US"
    },
    {
        "name": "Uruguay",
        "dial_code": "+598",
        "code": "UY"
    },
    {
        "name": "Uzbekistan",
        "dial_code": "+998",
        "code": "UZ"
    },
    {
        "name": "Vanuatu",
        "dial_code": "+678",
        "code": "VU"
    },
    {
        "name": "Venezuela, Bolivarian Republic of Venezuela",
        "dial_code": "+58",
        "code": "VE"
    },
    {
        "name": "Vietnam",
        "dial_code": "+84",
        "code": "VN"
    },
    {
        "name": "Virgin Islands, British",
        "dial_code": "+1284",
        "code": "VG"
    },
    {
        "name": "Virgin Islands, U.S.",
        "dial_code": "+1340",
        "code": "VI"
    },
    {
        "name": "Wallis and Futuna",
        "dial_code": "+681",
        "code": "WF"
    },
    {
        "name": "Yemen",
        "dial_code": "+967",
        "code": "YE"
    },
    {
        "name": "Zambia",
        "dial_code": "+260",
        "code": "ZM"
    },
    {
        "name": "Zimbabwe",
        "dial_code": "+263",
        "code": "ZW"
    }
]